var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArchivVerwerfen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4388",
    "data-name": "Group 4388",
    transform: "translate(-6013 -6700)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6013 6700)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_7_",
    "data-name": "download (7)",
    transform: "translate(5854.126 6573.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M228.3,155.52H214.874v-3a1.471,1.471,0,0,0-1.474-1.474h-8.947a1.471,1.471,0,0,0-1.474,1.474v3H189.454a1.471,1.471,0,0,0-1.474,1.474v3a1.471,1.471,0,0,0,1.474,1.474h38.841a1.471,1.471,0,0,0,1.474-1.474v-3a1.471,1.471,0,0,0-1.474-1.474Z",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M250.726,278.45h-34.1a.746.746,0,0,0-.737.842l3.842,31.052a4.5,4.5,0,0,0,4.474,3.947h18.947a4.534,4.534,0,0,0,4.474-3.947l3.895-31.052a.76.76,0,0,0-.79-.842Zm-10.368,21.368a1.811,1.811,0,0,1,0,2.526,1.78,1.78,0,0,1-2.527,0l-4.157-4.158-4.158,4.158a1.78,1.78,0,0,1-2.526,0,1.811,1.811,0,0,1,0-2.526l4.158-4.158-4.158-4.158a1.786,1.786,0,0,1,2.526-2.526l4.158,4.158,4.158-4.158a1.786,1.786,0,0,1,2.526,2.526L236.2,295.66Z",
    transform: "translate(-24.799 -113.245)",
    fill: "#00c4de"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchivVerwerfen);
export default __webpack_public_path__ + "static/media/Icon_archiv_verwerfen.77c2695957841026973aaa97d3ec786a.svg";
export { ForwardRef as ReactComponent };